/**
 * Directive `v-only-digits` : restreint la saisie d'un champ aux chiffres uniquement.
 *
 * Appliquée aux champs "code postal" et "téléphone". Elle nettoie la valeur à chaque
 * saisie (frappe, collage, glisser-déposer, autocomplétion), puis réémet un évènement
 * `input` pour que le `v-model` reste synchronisé avec la valeur affichée.
 *
 * Usage : <input type="text" v-model="form.codePostal" v-only-digits />
 */

const NON_DIGITS = /\D/g;
const DIGITS = /\d/g;

function resolveInput(el) {
  return el.tagName === "INPUT" ? el : el.querySelector("input");
}

function sanitize(event) {
  const input = event.currentTarget;

  // On laisse la composition (clavier IME) se terminer avant de nettoyer.
  if (event.isComposing) return;

  const value = input.value;
  const cleaned = value.replace(NON_DIGITS, "");
  if (cleaned === value) return;

  // Le curseur doit rester là où l'utilisateur écrivait, sans compter
  // les caractères qui viennent d'être supprimés.
  const caret = input.selectionStart === null ? cleaned.length : input.selectionStart;
  const removedBefore = value.slice(0, caret).replace(DIGITS, "").length;
  const nextCaret = caret - removedBefore;

  input.value = cleaned;

  try {
    input.setSelectionRange(nextCaret, nextCaret);
  } catch (error) {
    // Certains navigateurs n'exposent pas la sélection selon le type de champ.
  }

  // Indispensable pour que le v-model récupère la valeur nettoyée.
  input.dispatchEvent(new Event("input", { bubbles: true }));
}

export default {
  mounted(el) {
    const input = resolveInput(el);
    if (!input) return;

    // Affiche le pavé numérique sur mobile.
    if (!input.hasAttribute("inputmode")) {
      input.setAttribute("inputmode", "numeric");
    }

    input.addEventListener("input", sanitize);
    input.addEventListener("compositionend", sanitize);
    el._onlyDigitsInput = input;
  },

  unmounted(el) {
    const input = el._onlyDigitsInput;
    if (!input) return;

    input.removeEventListener("input", sanitize);
    input.removeEventListener("compositionend", sanitize);
    delete el._onlyDigitsInput;
  },
};
